export const traduireTypeDeMission = (typeDeMission) => {
    const traductionsTypeDeMission = {
        FIRST_INSPECTION: "Demande Première Expertise",
        SECOND_INSPECTION : "Demande Deuxième Expertise",
        COUNTER_INSPECTION: "Contre-Expertise",
        ARBITRATION: "Arbitrage",
        MAE_CLIENT_ARBITRATION: "Arbitrage Client MAE",
        CARRENCE_REPORT: "Rapport de carrence",
        JUDICIAL_INSPECTION: "Expertise judiciaire",
    };
    return traductionsTypeDeMission[typeDeMission] || typeDeMission;
};

export const traduireTypeDeMissionForTask  = (typeDeMission) => {
    const traductionsTypeDeMission = {
        FIRST_INSPECTION: "Première Expertise",
        SECOND_INSPECTION : "Deuxième Expertise",
        COUNTER_INSPECTION: "Contre-Expertise",
        ARBITRATION: "Arbitrage",
        MAE_CLIENT_ARBITRATION: "Arbitrage Client MAE",
        CARRENCE_REPORT: "Rapport de carrence",
        JUDICIAL_INSPECTION: "Expertise judiciaire",
    };
    return traductionsTypeDeMission[typeDeMission] || typeDeMission;
};